import type { CostAndCharge } from 'models/streaming/costsAndCharges';
import { FormattedMessage } from 'react-intl';

import { useCostAndChargesDescription, useFormatAndSortCostsAndCharges } from './CostsAndCharges.helper';

export interface CostsAndChargesProps {
  costsAndCharges: CostAndCharge[];
}

export function CostsAndCharges({ costsAndCharges }: CostsAndChargesProps) {
  const costAndChargesDescription = useCostAndChargesDescription(costsAndCharges);
  const costAndChargesBody = useFormatAndSortCostsAndCharges(costsAndCharges);
  return (
    <div>
      <p className="text-start mb-3" data-e2e="costs-and-charges-description">
        {costAndChargesDescription}
      </p>
      <p className="text-start mb-3" data-e2e="costs-and-charges-mifid-disclaimer">
        <FormattedMessage id="costAndCharge.mifidDisclaimer" />
      </p>
      <table className="table table-striped bg-lvl1 table-sm" data-e2e="costs-and-charges-table">
        <tbody>
          {costAndChargesBody.map(({ id, name, value, category }) => (
            <tr id={id} key={name}>
              <td data-e2e="cost-and-charge-name">{name}</td>
              <td data-e2e="cost-and-charge-value">{value}</td>
              <td data-e2e="cost-and-charge-category">{category}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
